import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { getBulletsForBillingPlan, getUpsellModalContent } from '../helper';

import styles from './feature-description.module.css';

import type { UpsellModalContentCode } from '../../../constants/upsell-modal-content-codes';

type FeatureDescriptionProps = {
  upsellModalContentCode: UpsellModalContentCode;
  planName: string;
  billingPlanId: number | null;
};

export const FeatureDescription = ({ upsellModalContentCode, planName, billingPlanId }: FeatureDescriptionProps) => {
  const content = getUpsellModalContent(upsellModalContentCode);
  const bulletContent = billingPlanId && content.isNewLineupBillingPlanUpsell ? getBulletsForBillingPlan(billingPlanId) : content.bullets;

  return (
    <>
      {content.tagline ? (
        <Text className={styles.tagline} formattedMessageValues={{ planName }} textType={TextType.H2} value={content.tagline} />
      ) : null}
      {bulletContent ? (
        <ul className={styles.bullets}>
          <FormattedMessage {...bulletContent} values={{ li: (chunks) => <li>{chunks}</li> }} />
        </ul>
      ) : null}
    </>
  );
};
